import translate from '../i18n/config';

export const API_PREFIX = '/api/';

export const API_URL = process.env.REACT_APP_API_URL;

const ENTITY = {
  auth: 'auth',
  users: 'user',
  roles: 'role',
  properties: 'property',
  platform: 'platform',
  vendor: 'vendor',
  transactions: 'transaction',
  serviceTypes: 'service-type',
  transactionType: 'transaction-type',
  customers: 'customer',
  reservations: 'reservation',
  invoices: 'invoice',
  payments: 'payment',
  payouts: 'reconciliation-payout',
  account: 'account',
  countries: 'country',
  states: 'state',
  city: 'city',
  genericLookup: 'generic-lookup',
  userPropertyAssignment: 'user-property-assignment',
  propertyVisits: 'property-visit',
  managerStatement: 'manager-statement',
};

export const PATH = {
  login: 'login',
  logout: 'logout',
  forgotPassword: 'forgot-password',
  resetPassword: 'reset-password',
  search: 'search',
  preview: 'preview',
  complete: 'mark-as-complete',
  sendEmail: 'send-email',
  add: 'add',
  managers: 'manager',
  lookup: 'lookup',
  syncHospitable: 'sync-hospitable',
  changePassword: 'change-password',
  kpis: 'kpi',
  properties: 'properties',
  users: 'users',
  transactions: 'transactions',
  bankAccount: 'bank_account',
  payout: 'payout',
  sync: 'sync'
};

const API_PATHS = {
  login: `${ENTITY.auth}/${PATH.login}`,
  logout: `${ENTITY.auth}/${PATH.logout}`,
  forgotPassword: `${ENTITY.auth}/${PATH.forgotPassword}`,
  resetPassword: `${ENTITY.auth}/${PATH.resetPassword}`,
  listUsers: `${ENTITY.users}/${PATH.search}`,
  listProperties: `${ENTITY.properties}/${PATH.search}`,
  properties: `${ENTITY.properties}`,
  listTransactions: `${ENTITY.transactions}/${PATH.search}`,
  transactions: `${ENTITY.transactions}`,
  users: `${ENTITY.users}`,
  vendors: `${ENTITY.vendor}`,
  customers: `${ENTITY.customers}`,
  listVendors: `${ENTITY.vendor}/${PATH.search}`,
  listCustomers: `${ENTITY.customers}/${PATH.search}`,
  vendorListKpis: `${ENTITY.vendor}/${PATH.kpis}`,
  propertyKpis: `${ENTITY.properties}/${PATH.kpis}`,
  customerKpis: `${ENTITY.customers}/${PATH.kpis}`,
  changePassword: `${ENTITY.users}/${PATH.changePassword}`,
  userListKpis: `${ENTITY.users}/${PATH.kpis}`,
  listRoles: `${ENTITY.roles}/${PATH.search}`,
  lookupUsers: `${ENTITY.users}/${PATH.lookup}`,
  lookupVendors: `${ENTITY.vendor}/${PATH.lookup}`,
  lookupRoles: `${ENTITY.roles}/${PATH.lookup}`,
  lookupCustomers: `${ENTITY.customers}/${PATH.lookup}`,
  lookupProperties: `${ENTITY.properties}/${PATH.lookup}`,
  lookupManagers: `${ENTITY.users}/${PATH.lookup}`,
  lookupStatementManagers: `${ENTITY.users}/${PATH.managers}/${PATH.lookup}`,
  listManagerStatements: `${ENTITY.managerStatement}/${PATH.search}`,
  generateManagerStatement: `${ENTITY.managerStatement}`,
  getManagerStatement: (id: string) => `${ENTITY.managerStatement}/${id}`,
  getManagerStatementCommissionPayouts: (id: string) => `${ENTITY.managerStatement}/${id}/commission-payouts`,
  adjustManagerStatementCommissionPayout: (id: string, invoiceId: string) => `${ENTITY.managerStatement}/${id}/commission-payouts/${invoiceId}/adjust`,
  getManagerStatementTransactions: (id: string) => `${ENTITY.managerStatement}/${id}/transactions`,
  adjustManagerStatementTransaction: (id: string, transactionId: string) => `${ENTITY.managerStatement}/${id}/transactions/${transactionId}/adjust`,
  saveManagerStatementCleaning: (id: string) => `${ENTITY.managerStatement}/${id}/cleaning`,
  getManagerStatementPropertyVisitBifurcation: (id: string, invoiceId: string) => `${ENTITY.managerStatement}/${id}/commission-payouts/${invoiceId}/property-visit-bifurcation`,
  getManagerStatementDocument: (id: string) => `${ENTITY.managerStatement}/${id}/documents/statement`,
  getManagerStatementInvoiceDocument: (id: string) => `${ENTITY.managerStatement}/${id}/documents/invoice`,
  serviceTypesLookup: `${ENTITY.serviceTypes}/${PATH.lookup}`,
  lookupCountries: `${ENTITY.countries}/${PATH.lookup}`,
  lookupStates: `${ENTITY.states}/${PATH.lookup}`,
  lookupCities: `${ENTITY.city}/${PATH.lookup}`,
  lookupGeneric: `${ENTITY.genericLookup}/${PATH.lookup}`,
  userPropertyAssignment: `${ENTITY.userPropertyAssignment}`,
  userProperties: `${ENTITY.users}/${PATH.properties}/${PATH.search}`,
  propertyUsers: `${ENTITY.properties}/${PATH.users}/${PATH.search}`,
  customerProperties: `${ENTITY.customers}/${PATH.properties}/${PATH.search}`,
  transactionsKpis: `${ENTITY.transactions}/${PATH.kpis}`,
  lookupTransactionTypes: `${ENTITY.transactionType}/${PATH.lookup}`,
  lookupPlatforms: `${ENTITY.platform}/${PATH.lookup}`,
  listReservations: `${ENTITY.reservations}/${PATH.search}`,
  reservations: `${ENTITY.reservations}`,
  lookupReservations: `${ENTITY.reservations}/${PATH.lookup}`,
  syncReservations: `${ENTITY.reservations}/${PATH.syncHospitable}`,
  reservationPayoutDetails: (id: string) => `${ENTITY.reservations}/payout-details/${id}`,
  commissionSettings: (id: string) => `${ENTITY.users}/${id}/commission-settings`,
  listInvoices: `${ENTITY.invoices}/${PATH.search}`,
  invoices: `${ENTITY.invoices}`,
  invoicePreview: (id: string) => `${ENTITY.invoices}/${id}/${PATH.preview}`,
  invoiceComplete: `${ENTITY.invoices}/${PATH.complete}`,
  invoiceSendEmail: (id: string) => `${ENTITY.invoices}/${id}/${PATH.sendEmail}`,
  listPayments: `${ENTITY.payments}/${PATH.search}`,
  payments: `${ENTITY.payments}`,
  paymentKpis: `${ENTITY.payments}/${PATH.kpis}`,
  lookupAccounts: `${ENTITY.account}/${PATH.lookup}`,
  lookupPaymentMethods: `${ENTITY.payments}/${PATH.lookup}`,
  lookupInvoice: `${ENTITY.invoices}/${PATH.lookup}`,
  listPayouts: `${ENTITY.payouts}/${PATH.search}`,
  lookupPayoutBankAccounts: `${ENTITY.payouts}/${PATH.bankAccount}/${PATH.lookup}`,
  lookupPayoutTypes: `${ENTITY.payouts}/${PATH.payout}/${PATH.lookup}`,
  payouts: `${ENTITY.payouts}`,
  syncPayouts: `${PATH.payout}/${PATH.sync}`,
  addPayout: (id: string) => `${ENTITY.payouts}/add-payout/${id}`,
  listPropertyVisits: `${ENTITY.propertyVisits}/${PATH.search}`,
  propertyVisits: `${ENTITY.propertyVisits}`,
  lookupPropertyVisitTypes: `${ENTITY.propertyVisits}/visit-type/${PATH.lookup}`,
  lookupPropertyVisitUserRoles: `${ENTITY.propertyVisits}/role/${PATH.lookup}`,
  lookupPropertyVisitVisitedBy: `${ENTITY.propertyVisits}/visited-by/${PATH.lookup}`,
  lookupPropertyVisitStatuses: `${ENTITY.propertyVisits}/status/${PATH.lookup}`,
  propertyVisitTasks: (visitId: string) => `${ENTITY.propertyVisits}/${visitId}/tasks`,
  propertyVisitTask: (visitId: string) => `${ENTITY.propertyVisits}/${visitId}/tasks`,
  propertyVisitTaskById: (visitId: string, taskId: string) => `${ENTITY.propertyVisits}/${visitId}/tasks/${taskId}`,
  propertyVisitDocument: (visitId: string) => `${ENTITY.propertyVisits}/${visitId}/documents`,
  propertyVisitDocumentById: (visitId: string, docId: string) => `${ENTITY.propertyVisits}/${visitId}/documents/${docId}`,
  propertyVisitUploadInit: `${ENTITY.propertyVisits}/documents/upload/init`,
  propertyVisitUploadChunk: `${ENTITY.propertyVisits}/documents/upload/chunk`,
  propertyVisitUploadComplete: `${ENTITY.propertyVisits}/documents/upload/complete`,
  propertyVisitUploadCancel: (uploadId: string) => `${ENTITY.propertyVisits}/documents/upload/${uploadId}`,
  checkActiveGuest: `${ENTITY.propertyVisits}/guest-check`,
};

export const API_ENDPOINTS = {
  login: API_PREFIX + API_PATHS.login,
  logout: API_PREFIX + API_PATHS.logout,
  forgotPassword: API_PREFIX + API_PATHS.forgotPassword,
  resetPassword: API_PREFIX + API_PATHS.resetPassword,
  listUsers: API_PREFIX + API_PATHS.listUsers,
  addUser: API_PREFIX + API_PATHS.users,
  editUser: API_PREFIX + API_PATHS.users,
  changePassword: API_PREFIX + API_PATHS.changePassword,
  getUser: API_PREFIX + API_PATHS.users,
  lookupUsers: API_PREFIX + API_PATHS.lookupUsers,
  lookupVendors: API_PREFIX + API_PATHS.lookupVendors,
  userListKpis: API_PREFIX + API_PATHS.userListKpis,
  lookupManagers: API_PREFIX + API_PATHS.lookupManagers,
  lookupStatementManagers: API_PREFIX + API_PATHS.lookupStatementManagers,
  listManagerStatements: API_PREFIX + API_PATHS.listManagerStatements,
  generateManagerStatement: API_PREFIX + API_PATHS.generateManagerStatement,
  getManagerStatement: (id: string) => `${API_PREFIX}${API_PATHS.getManagerStatement(id)}`,
  getManagerStatementCommissionPayouts: (id: string) => `${API_PREFIX}${API_PATHS.getManagerStatementCommissionPayouts(id)}`,
  adjustManagerStatementCommissionPayout: (id: string, invoiceId: string) => `${API_PREFIX}${API_PATHS.adjustManagerStatementCommissionPayout(id, invoiceId)}`,
  getManagerStatementTransactions: (id: string) => `${API_PREFIX}${API_PATHS.getManagerStatementTransactions(id)}`,
  adjustManagerStatementTransaction: (id: string, transactionId: string) => `${API_PREFIX}${API_PATHS.adjustManagerStatementTransaction(id, transactionId)}`,
  saveManagerStatementCleaning: (id: string) => `${API_PREFIX}${API_PATHS.saveManagerStatementCleaning(id)}`,
  getManagerStatementPropertyVisitBifurcation: (id: string, invoiceId: string) => `${API_PREFIX}${API_PATHS.getManagerStatementPropertyVisitBifurcation(id, invoiceId)}`,
  getManagerStatementDocument: (id: string) => `${API_PREFIX}${API_PATHS.getManagerStatementDocument(id)}`,
  getManagerStatementInvoiceDocument: (id: string) => `${API_PREFIX}${API_PATHS.getManagerStatementInvoiceDocument(id)}`,
  listRoles: API_PREFIX + API_PATHS.listRoles,
  lookupRoles: API_PREFIX + API_PATHS.lookupRoles,
  listProperties: API_PREFIX + API_PATHS.listProperties,
  properties: API_PREFIX + API_PATHS.properties,
  listTransactions: API_PREFIX + API_PATHS.listTransactions,
  transactions: API_PREFIX + API_PATHS.transactions,
  lookupProperties: API_PREFIX + API_PATHS.lookupProperties,
  listVendors: API_PREFIX + API_PATHS.listVendors,
  vendorListKpis: API_PREFIX + API_PATHS.vendorListKpis,
  propertyKpis: API_PREFIX + API_PATHS.propertyKpis,
  vendors: API_PREFIX + API_PATHS.vendors,
  listCustomers: API_PREFIX + API_PATHS.listCustomers,
  lookupCustomers: API_PREFIX + API_PATHS.lookupCustomers,
  customerKpis: API_PREFIX + API_PATHS.customerKpis,
  customers: API_PREFIX + API_PATHS.customers,
  serviceTypesLookup: API_PREFIX + API_PATHS.serviceTypesLookup,
  lookupCountries: API_PREFIX + API_PATHS.lookupCountries,
  lookupStates: API_PREFIX + API_PATHS.lookupStates,
  lookupCities: API_PREFIX + API_PATHS.lookupCities,
  lookupGeneric: API_PREFIX + API_PATHS.lookupGeneric,
  assignRemoveUserProperty: API_PREFIX + API_PATHS.userPropertyAssignment,
  bulkAssignUserProperty: API_PREFIX + API_PATHS.userPropertyAssignment + '/bulk-assign',
  userProperties: API_PREFIX + API_PATHS.userProperties,
  propertyUsers: API_PREFIX + API_PATHS.propertyUsers,
  customerProperties: API_PREFIX + API_PATHS.customerProperties,
  transactionsKpis: API_PREFIX + API_PATHS.transactionsKpis,
  lookupTransactionTypes: API_PREFIX + API_PATHS.lookupTransactionTypes,
  lookupPlatforms: API_PREFIX + API_PATHS.lookupPlatforms,
  listReservations: API_PREFIX + API_PATHS.listReservations,
  reservations: API_PREFIX + API_PATHS.reservations,
  lookupReservations: API_PREFIX + API_PATHS.lookupReservations,
  syncReservations: API_PREFIX + API_PATHS.syncReservations,
  reservationPayoutDetails: (id: string) => API_PREFIX + API_PATHS.reservationPayoutDetails(id),
  commissionSettings: (id: string) => API_PREFIX + API_PATHS.commissionSettings(id),
  listInvoices: API_PREFIX + API_PATHS.listInvoices,
  invoices: API_PREFIX + API_PATHS.invoices,
  invoicePreview: (id: string) => `${API_PREFIX}${API_PATHS.invoicePreview(id)}`,
  invoiceComplete: API_PREFIX + API_PATHS.invoiceComplete,
  invoiceSendEmail: (id: string) => `${API_PREFIX}${API_PATHS.invoiceSendEmail(id)}`,
  lookupInvoice: API_PREFIX + API_PATHS.lookupInvoice,
  listPayments: API_PREFIX + API_PATHS.listPayments,
  payments: API_PREFIX + API_PATHS.payments,
  paymentKpis: API_PREFIX + API_PATHS.paymentKpis,
  lookupAccounts: API_PREFIX + API_PATHS.lookupAccounts,
  lookupPaymentMethods: API_PREFIX + API_PATHS.lookupPaymentMethods,
  listPayouts: API_PREFIX + API_PATHS.listPayouts,
  lookupPayoutBankAccounts: API_PREFIX + API_PATHS.lookupPayoutBankAccounts,
  lookupPayoutTypes: API_PREFIX + API_PATHS.lookupPayoutTypes,
  payouts: API_PREFIX + API_PATHS.payouts,
  syncPayouts: API_PREFIX + API_PATHS.syncPayouts,
  addPayout: (id: string) => `${API_PREFIX}${API_PATHS.addPayout(id)}`,
  listPropertyVisits: API_PREFIX + API_PATHS.listPropertyVisits,
  propertyVisits: API_PREFIX + API_PATHS.propertyVisits,
  lookupPropertyVisitTypes: API_PREFIX + API_PATHS.lookupPropertyVisitTypes,
  lookupPropertyVisitUserRoles: API_PREFIX + API_PATHS.lookupPropertyVisitUserRoles,
  lookupPropertyVisitVisitedBy: API_PREFIX + API_PATHS.lookupPropertyVisitVisitedBy,
  lookupPropertyVisitStatuses: API_PREFIX + API_PATHS.lookupPropertyVisitStatuses,
  propertyVisitTasks: (visitId: string) => `${API_PREFIX}${API_PATHS.propertyVisitTasks(visitId)}`,
  propertyVisitTask: (visitId: string) => `${API_PREFIX}${API_PATHS.propertyVisitTask(visitId)}`,
  propertyVisitTaskById: (visitId: string, taskId: string) => `${API_PREFIX}${API_PATHS.propertyVisitTaskById(visitId, taskId)}`,
  propertyVisitDocument: (visitId: string) => `${API_PREFIX}${API_PATHS.propertyVisitDocument(visitId)}`,
  propertyVisitDocumentById: (visitId: string, docId: string) => `${API_PREFIX}${API_PATHS.propertyVisitDocumentById(visitId, docId)}`,
  propertyVisitUploadInit: API_PREFIX + API_PATHS.propertyVisitUploadInit,
  propertyVisitUploadChunk: API_PREFIX + API_PATHS.propertyVisitUploadChunk,
  propertyVisitUploadComplete: API_PREFIX + API_PATHS.propertyVisitUploadComplete,
  propertyVisitUploadCancel: (uploadId: string) => `${API_PREFIX}${API_PATHS.propertyVisitUploadCancel(uploadId)}`,
  checkActiveGuest: API_PREFIX + API_PATHS.checkActiveGuest,
};

export const STATUS_CODE = {
  unauthorized: 401,
  badRequest: 400,
  unProcessableEntity: 422,
  forbidden: 403,
  notFound: 404,
  internalServerError: 500,
  gatewayTimeout: 504,
  entityTooLarge: 413,
  conflict: 409,
};

export const ERROR_MESSAGES = {
  internalServerError: translate.t('common.errorMessages.internalServerError'),
  unauthorized: translate.t('common.errorMessages.unauthorized'),
  badRequest: translate.t('common.errorMessages.badRequest'),
  apiPathNotFound: translate.t('common.errorMessages.apiPathNotFound'),
  forbidden: translate.t('common.errorMessages.forbidden'),
  gatewayTimeout: translate.t('common.errorMessages.gatewayTimeout'),
};
